var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M4 13C5.38071 13 6.5 11.8807 6.5 10.5C6.5 9.11929 5.38071 8 4 8C2.61929 8 1.5 9.11929 1.5 10.5C1.5 11.8807 2.61929 13 4 13Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12 13C13.3807 13 14.5 11.8807 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.8807 10.6193 13 12 13Z",
    fill: "#6C7689"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.875 5.75C5.875 5.40482 6.15482 5.125 6.5 5.125H9.5C9.84518 5.125 10.125 5.40482 10.125 5.75C10.125 6.09518 9.84518 6.375 9.5 6.375H6.5C6.15482 6.375 5.875 6.09518 5.875 5.75Z",
    fill: "#6C7689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06043 2.9912C9.45944 2.59643 9.99808 2.375 10.5594 2.375C11.1207 2.375 11.6593 2.59643 12.0583 2.9912C12.1142 3.04648 12.1591 3.1118 12.1908 3.18375L14.9221 9.39C15.0611 9.70593 14.9177 10.0748 14.6018 10.2138C14.2858 10.3528 13.917 10.2094 13.7779 9.8935L11.1013 3.81132C10.9472 3.69118 10.7567 3.625 10.5594 3.625C10.4058 3.625 10.2564 3.66508 10.125 3.73949V10.498C10.125 10.8432 9.84518 11.123 9.5 11.123C9.15482 11.123 8.875 10.8432 8.875 10.498V3.4355C8.875 3.26858 8.94177 3.1086 9.06043 2.9912Z",
    fill: "#6C7689"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94207 2.9912C4.34108 2.59643 4.87972 2.375 5.44102 2.375C6.00231 2.375 6.54095 2.59643 6.93997 2.9912C7.05862 3.1086 7.12539 3.26858 7.12539 3.4355V10.498C7.12539 10.8432 6.84557 11.123 6.50039 11.123C6.15521 11.123 5.87539 10.8432 5.87539 10.498V3.73949C5.74404 3.66508 5.59458 3.625 5.44102 3.625C5.2437 3.625 5.05315 3.69118 4.89909 3.81132L2.22245 9.8935C2.08341 10.2094 1.71458 10.3528 1.39864 10.2138C1.0827 10.0748 0.939298 9.70593 1.07834 9.39L3.80959 3.18375C3.84125 3.1118 3.88619 3.04648 3.94207 2.9912Z",
    fill: "#6C7689"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.625C2.96447 8.625 2.125 9.46447 2.125 10.5C2.125 11.5355 2.96447 12.375 4 12.375C5.03553 12.375 5.875 11.5355 5.875 10.5C5.875 9.46447 5.03553 8.625 4 8.625ZM0.875 10.5C0.875 8.77411 2.27411 7.375 4 7.375C5.72589 7.375 7.125 8.77411 7.125 10.5C7.125 12.2259 5.72589 13.625 4 13.625C2.27411 13.625 0.875 12.2259 0.875 10.5Z",
    fill: "#6C7689"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.625C10.9645 8.625 10.125 9.46447 10.125 10.5C10.125 11.5355 10.9645 12.375 12 12.375C13.0355 12.375 13.875 11.5355 13.875 10.5C13.875 9.46447 13.0355 8.625 12 8.625ZM8.875 10.5C8.875 8.77411 10.2741 7.375 12 7.375C13.7259 7.375 15.125 8.77411 15.125 10.5C15.125 12.2259 13.7259 13.625 12 13.625C10.2741 13.625 8.875 12.2259 8.875 10.5Z",
    fill: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.bcd3caa4781c2afa22a92dd86c2bc724.svg";
export { ForwardRef as ReactComponent };